import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { Save } from '@material-ui/icons';
import { Grid, Button, Paper } from "@material-ui/core";
import { ValidatorForm } from 'react-material-ui-form-validator'

import { CONTRATACIONES_CONTABLES_PERMISOS } from '../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { MENU_CONTRATACIONES } from '../../../../utils/constants';
import { deleteCuentasContables, fetchCuentasContables, updateCuentasContables } from '../../../../actions/contrataciones/contratacionesDatosContables';
import Buscador from '../../../../actions/ui/Buscador';
import { useForm } from '../../../../hooks/useForm';
import { ModalAddCuenta } from '../ui/ModalAddCuenta';

const centerStyle = {display: "flex", justifyContent: "center", alignItems: "center"};

const addCuentaValues = {
    idPlandeCuenta: "",
}

const initalValues = ({cuenta, id}) => (
    cuenta !== null 
    ? { ...cuenta, idEfectorFacturacion: id }
    : {...addCuentaValues, idEfectorFacturacion: id}
)

export const CuentasContablesTab = (props) => {
    const dispatch = useDispatch();

    const { cuentas } = useSelector((state) => state.contratacionesDatosBancarios);
    const { dataContrato } = useSelector((state) => state.contrataciones);
    const { permisos: permisosUser } = useSelector((state) => state.auth);
    const isDisabled = !validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTABLES_PERMISOS.ADMINISTRAR) || props.menu === MENU_CONTRATACIONES.CONSULTA

    const [open, setOpen] = useState(false)

    useEffect(() => dataContrato?.idEfectorFacturacion && dispatch(fetchCuentasContables()), [dataContrato]);

    return (
        <div style={{padding: "1.5em"}}>
            {open && (
                <ModalAddCuenta 
                    open={open}
                    setOpen={setOpen}
                    idEfectorFacturacion={dataContrato?.idEfectorFacturacion}
                />
            )}
            <Grid container justify={"flex-start"} style={{gap: "1.5em"}}>
                {cuentas.length > 0 && cuentas.map((item, index) => (
                    <CuentaCard 
                        key={index} 
                        contrato={dataContrato} 
                        item={item} 
                        isDisabled={isDisabled}
                    />
                ))}
                <Grid 
                    item xs={12} md={3} 
                    component={Paper} elevation={2}
                    style={{...centerStyle, padding: "5em"}}
                >
                    <Button
                        variant='outlined'
                        type='button'
                        color='primary'
                        size='large'
                        onClick={() => setOpen(true)}
                        disabled={isDisabled}
                    >
                        Agregar Cuenta
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
}

const CuentaCard = ({item, index, contrato, isDisabled}) => {
    const dispatch = useDispatch();
    
    const [cuentaValue, setCuentaValue] = useState({
        id: item?.idPlandeCuenta,
        cuenta: item?.cuenta,
        subCuenta: item?.subCuenta,
        descripcion: item?.descripcion
    });

    const [ 
        formValues,,,
        setearValor
    ] = useForm(initalValues({cuenta: item, id: contrato?.idEfectorFacturacion}));

    const submitHandler = (e) => {
        e.preventDefault();
        dispatch(updateCuentasContables(formValues));
    }

    return (
        <Grid key={index} item xs={12} md={4} component={Paper} elevation={2} style={{padding: "1.5em"}}>
            <ValidatorForm onSubmit={submitHandler}>
                <Grid container spacing={2} style={{display: "flex", flexDirection: "column"}}>
                    <Grid item xs={12}>
                        <Buscador 
                            value={cuentaValue}
                            variant="outlined"
                            setValue={(val) => {
                                setCuentaValue(val);
                                setearValor("idPlandeCuenta", val?.id);
                            }}
                            label="Plan de Cuentas" 
                            endpoint={(texto) => `PlanCuentas/traerPorParametros?texto=${texto.replace("/", "__")}`}
                            noOptionText={"No se encuentra plan cuentas"}
                            getOptionLabel={(option) =>`${option.cuenta}-${option.subCuenta} - ${option.descripcion}`}
                            renderOption={(option) =>`${option.cuenta}-${option.subCuenta} - ${option.descripcion}`}
                            validators={{
                                values: ["required"],
                                msgs: ["Este campo es obligatorio"]
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} style={{...centerStyle, gap: "1em", marginTop: "0.5em"}}>
                        <Button
                            variant='outlined'
                            type='button'
                            color='secondary'
                            onClick={() => {
                                dispatch(deleteCuentasContables(item.id));
                            }}
                            disabled={isDisabled}
                        >
                            Eliminar Cuenta
                        </Button>
                        <Button
                            variant='contained'
                            type='submit'
                            color='primary'
                            startIcon={<Save />}
                            disabled={isDisabled}
                        >
                            Guardar Datos
                        </Button>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </Grid>
    )
};